const config = {
    sentry: {
        dns: 'https://743631c2e9da471e812358817ff94921@o500855.ingest.sentry.io/5581258',
    },
};

export default config;
